import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCode = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" height={48} viewBox="0 96 960 960" width={48} {...props}><path d="M320 814 80 574l242-242 43 43-199 199 197 197-43 43Zm318 2-43-43 199-199-197-197 43-43 240 240-242 242Z" /></svg>;
export default SvgIconCode;